import HCLTreeMxCellRenderer from "./HCLTreeMxCellRenderer";
import BayesianNetworkVertex from "../HCLTreeNode/BayesianNetworkNode/BayesianNetworkVertex";
import BayesianNetworkMxGraph from "../HCLTreeMxGraph/BayesianNetworkMxGraph";
import {mxCellRenderer} from "mxgraph-js";

class BayesianNetworkMxCellRenderer extends HCLTreeMxCellRenderer {

  registerShapes() {
    mxCellRenderer.registerShape(BayesianNetworkVertex.SHAPE_KEY, BayesianNetworkVertex.getShape());
  }

}

export default BayesianNetworkMxCellRenderer;
